import { useState } from 'react'
import { formatearPeso } from '../../utils/formato'

function fmtKg(kg) {
  if (!kg) return ''
  return kg < 1 ? `${Math.round(kg * 1000)}g` : `${parseFloat(kg.toFixed(3))}kg`
}

export default function ModalPeso({ producto, onConfirmar, onCancelar }) {
  // campo activo: 'peso' | 'precio'
  const [campo, setCampo] = useState('peso')
  const [inputPeso, setInputPeso] = useState('')
  const [inputPrecio, setInputPrecio] = useState('')
  const [precioManual, setPrecioManual] = useState(false)

  const kg = parseFloat(inputPeso) || 0
  const precioCalculado = parseFloat((kg * (producto?.precio || 0)).toFixed(2))
  const precioFinal = precioManual
    ? (parseFloat(inputPrecio) || 0)
    : precioCalculado

  const TECLAS = ['1','2','3','4','5','6','7','8','9','.','0','⌫']

  function presionar(t) {
    const setter = campo === 'peso' ? setInputPeso : setInputPrecio

    setter(prev => {
      if (t === '⌫') return prev.slice(0, -1)
      if (t === '.' && prev.includes('.')) return prev
      // Para peso: máx 3 decimales; para precio: máx 2 decimales
      const maxDec = campo === 'peso' ? 3 : 2
      const partes = (prev + t).split('.')
      if (partes[1] && partes[1].length > maxDec) return prev
      return prev + t
    })

    // Al cambiar el precio manualmente, activar modo manual
    if (campo === 'precio') setPrecioManual(true)
  }

  function activarPeso() {
    setCampo('peso')
  }

  function activarPrecio() {
    // Pre-llenar precio calculado si no había precio manual
    if (!precioManual && precioCalculado > 0) {
      setInputPrecio(String(precioCalculado))
    }
    setCampo('precio')
    setPrecioManual(true)
  }

  function resetPrecio() {
    setInputPrecio('')
    setPrecioManual(false)
    setCampo('peso')
  }

  function confirmar() {
    if (precioFinal <= 0) return
    onConfirmar({ kg: kg || null, precioFinal })
  }

  if (!producto) return null

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/70 backdrop-blur-sm">
      <div className="bg-tienda-surface rounded-t-3xl w-full max-w-lg p-5 space-y-4">

        {/* Producto */}
        <div className="flex items-center gap-3">
          <span className="text-3xl">{producto.emoji || '⚖️'}</span>
          <div className="flex-1">
            <p className="font-bold text-tienda-text">{producto.nombre}</p>
            <p className="text-tienda-muted text-sm">{formatearPeso(producto.precio)} / kg referencia</p>
          </div>
        </div>

        {/* Tabs campo activo */}
        <div className="flex gap-2 bg-tienda-bg rounded-xl p-1">
          <button
            onClick={activarPeso}
            className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors
              ${campo === 'peso' ? 'bg-tienda-surface text-tienda-accent shadow-sm' : 'text-tienda-muted'}`}
          >
            ⚖️ Peso
          </button>
          <button
            onClick={activarPrecio}
            className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors
              ${campo === 'precio' ? 'bg-tienda-surface text-tienda-accent shadow-sm' : 'text-tienda-muted'}`}
          >
            💰 Precio libre
          </button>
        </div>

        {/* Display */}
        <div className="bg-tienda-bg rounded-2xl p-4 space-y-2">
          {/* Fila peso */}
          <button
            onClick={activarPeso}
            className={`w-full flex items-center justify-between p-2 rounded-xl transition-colors
              ${campo === 'peso' ? 'bg-tienda-surface ring-1 ring-tienda-accent' : 'opacity-60'}`}
          >
            <span className="text-tienda-muted text-sm">Peso</span>
            <span className="text-xl font-bold text-tienda-text">
              {inputPeso ? `${inputPeso} kg` : <span className="text-tienda-muted text-base">—</span>}
            </span>
          </button>

          {/* Fila precio */}
          <button
            onClick={activarPrecio}
            className={`w-full flex items-center justify-between p-2 rounded-xl transition-colors
              ${campo === 'precio' ? 'bg-tienda-surface ring-1 ring-tienda-accent' : 'opacity-60'}`}
          >
            <span className="text-tienda-muted text-sm flex items-center gap-1">
              Precio {precioManual && (
                <span
                  onClick={e => { e.stopPropagation(); resetPrecio() }}
                  className="text-xs bg-tienda-accent/20 text-tienda-accent px-1.5 rounded-full"
                >
                  manual ×
                </span>
              )}
            </span>
            <span className={`text-xl font-bold ${precioManual ? 'text-tienda-accent' : 'text-tienda-text'}`}>
              {precioFinal > 0
                ? formatearPeso(precioFinal)
                : <span className="text-tienda-muted text-base">—</span>}
            </span>
          </button>
        </div>

        {/* Numpad */}
        <div className="grid grid-cols-3 gap-2">
          {TECLAS.map((t, i) => (
            <button
              key={i}
              onClick={() => presionar(t)}
              className={`h-13 py-3 rounded-2xl text-xl font-semibold active:scale-90 transition-transform
                bg-tienda-bg text-tienda-text border border-tienda-border
                ${t === '⌫' ? 'text-tienda-muted' : ''}`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* Acciones */}
        <div className="flex gap-3">
          <button onClick={onCancelar} className="btn-ghost flex-1 py-3 text-base">
            Cancelar
          </button>
          <button
            onClick={confirmar}
            disabled={precioFinal <= 0}
            className="btn-primary flex-1 py-3 text-base disabled:opacity-40"
          >
            {precioFinal > 0
              ? `Agregar · ${formatearPeso(precioFinal)}`
              : 'Agregar'}
          </button>
        </div>
      </div>
    </div>
  )
}
